import A from 'utils/metrics/analytic'

// Открыл клиническую рекомендацию
enum originClinRec {
  CLINICAL_LIST = 'clinical_list',
  NOORIGIN = 'noorigin',
}

const A_cr_openClinRec = (origin: originClinRec, id: number) => {
  if (origin === originClinRec.NOORIGIN) {
    A.setEvent('clinrec_open', { id: String(id) })
  } else {
    A.setEvent('clinrec_open', { origin, id: String(id) })
  }
}

export { A_cr_openClinRec, originClinRec }
